import * as Sentry from "@sentry/react";


const environment = process.env.REACT_APP_ENVIRONMENT;
const dsn = process.env.REACT_APP_SENTRY_DSN;

const tracesSampleRate = Number(process.env.REACT_APP_TRACES_SAMPLE_RATE ?? 0);
const replaysSessionSampleRate = Number(process.env.REACT_APP_REPLAYS_SESSION_SAMPLE_RATE ?? 0);
const replaysOnErrorSampleRate = Number(process.env.REACT_APP_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1);

const enableFeedback = String(process.env.REACT_APP_SENTRY_FEEDBACK).toLowerCase() === "true";

// Build integrations array conditionally
const integrations: any[] = [
  Sentry.browserTracingIntegration(),
  Sentry.replayIntegration(),
];

if (enableFeedback) {
  integrations.push(
    Sentry.feedbackIntegration({
      // comportamento
      autoInject: true,
      colorScheme: "system",
      showName: true,
      showEmail: true,
      isEmailRequired: true,
      enableScreenshot: true,

      // testi in ITA
      triggerLabel: "Segnala un problema",
      triggerAriaLabel: "Apri modulo feedback",
      formTitle: "Invia feedback",
      submitButtonLabel: "Invia segnalazione",
      cancelButtonLabel: "Annulla",
      confirmButtonLabel: "Conferma",
      addScreenshotButtonLabel: "Aggiungi screenshot",
      removeScreenshotButtonLabel: "Rimuovi screenshot",
      nameLabel: "Nome",
      namePlaceholder: "Il tuo nome",
      emailLabel: "Email",
      emailPlaceholder: "nome@esempio.it",
      isRequiredLabel: "(obbligatorio)",
      messageLabel: "Descrizione",
      messagePlaceholder: "Cos’è successo? Cosa ti aspettavi?",
      successMessageText: "Grazie per la tua segnalazione!",
      // opz.: strumenti di annotazione screenshot (SDK >= 10.10)
      highlightToolText: "Evidenzia",
      hideToolText: "Oscura",
      removeHighlightText: "Rimuovi",
    })
  );
};

if (dsn) {
  Sentry.init({
    environment,
    dsn,
    integrations,
    tracesSampleRate,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    sendDefaultPii: true,
    tracePropagationTargets: ["localhost", /^\//],
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection",
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i],
    beforeSend(event, hint) {
      const err: any = hint?.originalException;
      if (err?.name === "ChunkLoadError" || /Loading chunk \d+ failed/.test(err?.message || "")) {
        return null;
      }
      return event;
    },
    release: (window as any).__SENTRY_RELEASE__ || undefined,
  });
};

export { Sentry };

//bind sentry user
export type SentryUser = { id?: string; email?: string; username?: string };

export const bindSentryUser = (u: SentryUser | null) => {
  Sentry.setUser(u ? { id: u.id, email: u.email, username: u.username } : null);
};
